export const __INTERNAL_CLEAR_STORE__ = '__INTERNAL_CLEAR_STORE__'
export const __INTERNAL_DIALOG_SHOW__ = '__INTERNAL_DIALOG_SHOW__'
export const __INTERNAL_DIALOG_HIDE__ = '__INTERNAL_DIALOG_HIDE__'
export const __INTERNAL_DEVTOOLS_SHOW__ = '__INTERNAL_DEVTOOLS_SHOW__'
export const __INTERNAL_DEVTOOLS_HIDE__ = '__INTERNAL_DEVTOOLS_HIDE__'

// Logout
export const LOGOUT = 'LOGOUT'
export const LOGOUT_FORCE = 'LOGOUT_FORCE'
export const LOGOUT_LOADING = 'LOGOUT_LOADING'
export const LOGOUT_DONE = 'LOGOUT_DONE'

export const FETCH_USER = 'FETCH_USER'
export const FETCH_USER_LOADING = 'FETCH_USER_LOADING'
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS'
export const FETCH_USER_ERROR = 'FETCH_USER_ERROR'
export const FETCH_USER_DONE = 'FETCH_USER_DONE'

/////////// TENANT STATS////////

// Overview
export const FETCH_TENANT_STATS = 'FETCH_TENANT_STATS'
export const FETCH_TENANT_STATS_LOADING = 'FETCH_TENANT_STATS_LOADING'
export const FETCH_TENANT_STATS_SUCCESS = 'FETCH_TENANT_STATS_SUCCESS'
export const FETCH_TENANT_STATS_ERROR = 'FETCH_TENANT_STATS_ERROR'
export const FETCH_TENANT_STATS_DONE = 'FETCH_TENANT_STATS_DONE'

// Heroes
export const FETCH_HEROES = 'FETCH_HEROES'
export const FETCH_HEROES_LOADING = 'FETCH_HEROES_LOADING'
export const FETCH_HEROES_SUCCESS = 'FETCH_HEROES_SUCCESS'
export const FETCH_HEROES_ERROR = 'FETCH_HEROES_ERROR'
export const FETCH_HEROES_DONE = 'FETCH_HEROES_DONE'

// Popins

export const FETCH_POPINS = 'FETCH_POPINS'
export const FETCH_POPINS_LOADING = 'FETCH_POPINS_LOADING'
export const FETCH_POPINS_SUCCESS = 'FETCH_POPINS_SUCCESS'
export const FETCH_POPINS_ERROR = 'FETCH_POPINS_ERROR'
export const FETCH_POPINS_DONE = 'FETCH_POPINS_DONE'

// Users (by Tenant)

export const FETCH_USERS = 'FETCH_USERS'
export const FETCH_USERS_LOADING = 'FETCH_USERS_LOADING'
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS'
export const FETCH_USERS_ERROR = 'FETCH_USERS_ERROR'
export const FETCH_USERS_DONE = 'FETCH_USERS_DONE'

// Account Basics
export const UPDATE_ACCOUNT_NAME = 'UPDATE_ACCOUNT_NAME'
export const UPDATE_ACCOUNT_NAME_LOADING = 'UPDATE_ACCOUNT_NAME_LOADING'
export const UPDATE_ACCOUNT_NAME_SUCCESS = 'UPDATE_ACCOUNT_NAME_SUCCESS'
export const UPDATE_ACCOUNT_NAME_ERROR = 'UPDATE_ACCOUNT_NAME_ERROR'
export const UPDATE_ACCOUNT_NAME_DONE = 'UPDATE_ACCOUNT_NAME_DONE'

// Account Administrators
export const FETCH_ACCOUNT_ADMIN = 'FETCH_ACCOUNT_ADMIN'
export const FETCH_ACCOUNT_ADMIN_LOADING = 'FETCH_ACCOUNT_ADMIN_LOADING'
export const FETCH_ACCOUNT_ADMIN_SUCCESS = 'FETCH_ACCOUNT_ADMIN_SUCCESS'
export const FETCH_ACCOUNT_ADMIN_ERROR = 'FETCH_ACCOUNT_ADMIN_ERROR'
export const FETCH_ACCOUNT_ADMIN_DONE = 'FETCH_ACCOUNT_ADMIN_DONE'

export const ADD_NEW_ACCOUNT_ADMIN = 'ADD_NEW_ACCOUNT_ADMIN'
export const ADD_NEW_ACCOUNT_ADMIN_LOADING = 'ADD_NEW_ACCOUNT_ADMIN_LOADING'
export const ADD_NEW_ACCOUNT_ADMIN_SUCCESS = 'ADD_NEW_ACCOUNT_ADMIN_SUCCESS'
export const ADD_NEW_ACCOUNT_ADMIN_ERROR = 'ADD_NEW_ACCOUNT_ADMIN_ERROR'
export const ADD_NEW_ACCOUNT_ADMIN_DONE = 'ADD_NEW_ACCOUNT_ADMIN_DONE'

export const REMOVE_ACCOUNT_ADMIN = 'REMOVE_ACCOUNT_ADMIN'
export const REMOVE_ACCOUNT_ADMIN_LOADING = 'REMOVE_ACCOUNT_ADMIN_LOADING'
export const REMOVE_ACCOUNT_ADMIN_SUCCESS = 'REMOVE_ACCOUNT_ADMIN_SUCCESS'
export const REMOVE_ACCOUNT_ADMIN_ERROR = 'REMOVE_ACCOUNT_ADMIN_ERROR'
export const REMOVE_ACCOUNT_ADMIN_DONE = 'REMOVE_ACCOUNT_ADMIN_DONE'

export const TRANSFER_OWNER = 'TRANSFER_OWNER'
export const TRANSFER_OWNER_LOADING = 'TRANSFER_OWNER_LOADING'
export const TRANSFER_OWNER_SUCCESS = 'TRANSFER_OWNER_SUCCESS'
export const TRANSFER_OWNER_ERROR = 'TRANSFER_OWNER_ERROR'
export const TRANSFER_OWNER_DONE = 'TRANSFER_OWNER_DONE'

// Configuration Defaults
export const UPDATE_CONFIGURATION_DEFAULTS = 'UPDATE_CONFIGURATION_DEFAULTS'
export const UPDATE_CONFIGURATION_DEFAULTS_LOADING =
  'UPDATE_CONFIGURATION_DEFAULTS_LOADING'
export const UPDATE_CONFIGURATION_DEFAULTS_SUCCESS =
  'UPDATE_CONFIGURATION_DEFAULTS_SUCCESS'
export const UPDATE_CONFIGURATION_DEFAULTS_ERROR =
  'UPDATE_CONFIGURATION_DEFAULTS_ERROR'
export const UPDATE_CONFIGURATION_DEFAULTS_DONE =
  'UPDATE_CONFIGURATION_DEFAULTS_DONE'

// Authentication
export const UPDATE_AUTHENTICATION_METHOD = 'UPDATE_AUTHENTICATION_METHOD'
export const UPDATE_AUTHENTICATION_METHOD_LOADING =
  'UPDATE_AUTHENTICATION_METHOD_LOADING'
export const UPDATE_AUTHENTICATION_METHOD_SUCCESS =
  'UPDATE_AUTHENTICATION_METHOD_SUCCESS'
export const UPDATE_AUTHENTICATION_METHOD_ERROR =
  'UPDATE_AUTHENTICATION_METHOD_ERROR'
export const UPDATE_AUTHENTICATION_METHOD_DONE =
  'UPDATE_AUTHENTICATION_METHOD_DONE'

// Self Launch Allowed
export const FETCH_SELF_LAUNCH_LIST = 'FETCH_SELF_LAUNCH_LIST'
export const FETCH_SELF_LAUNCH_LIST_LOADING = 'FETCH_SELF_LAUNCH_LIST_LOADING'
export const FETCH_SELF_LAUNCH_LIST_SUCCESS = 'FETCH_SELF_LAUNCH_LIST_SUCCESS'
export const FETCH_SELF_LAUNCH_LIST_ERROR = 'FETCH_SELF_LAUNCH_LIST_ERROR'
export const FETCH_SELF_LAUNCH_LIST_DONE = 'FETCH_SELF_LAUNCH_LIST_DONE'

export const ADD_NEW_SELF_LAUNCH = 'ADD_NEW_SELF_LAUNCH'
export const ADD_NEW_SELF_LAUNCH_DONE = 'ADD_NEW_SELF_LAUNCH_DONE'
export const ADD_NEW_SELF_LAUNCH_ERROR = 'ADD_NEW_SELF_LAUNCH_ERROR'
export const ADD_NEW_SELF_LAUNCH_LOADING = 'ADD_NEW_SELF_LAUNCH_LOADING'
export const ADD_NEW_SELF_LAUNCH_SUCCESS = 'ADD_NEW_SELF_LAUNCH_SUCCESS'

export const REMOVE_SELF_LAUNCH = 'REMOVE_SELF_LAUNCH'
export const REMOVE_SELF_LAUNCH_DONE = 'REMOVE_SELF_LAUNCH_DONE'
export const REMOVE_SELF_LAUNCH_ERROR = 'REMOVE_SELF_LAUNCH_ERROR'
export const REMOVE_SELF_LAUNCH_LOADING = 'REMOVE_SELF_LAUNCH_LOADING'
export const REMOVE_SELF_LAUNCH_SUCCESS = 'REMOVE_SELF_LAUNCH_SUCCESS'

// Generated by 'generate-redux'
export const FETCH_ACTIVITIES_BY_USE_CASE = 'FETCH_ACTIVITIES_BY_USE_CASE'
export const FETCH_ACTIVITIES_BY_USE_CASE_LOADING =
  'FETCH_ACTIVITIES_BY_USE_CASE_LOADING'
export const FETCH_ACTIVITIES_BY_USE_CASE_SUCCESS =
  'FETCH_ACTIVITIES_BY_USE_CASE_SUCCESS'
export const FETCH_ACTIVITIES_BY_USE_CASE_ERROR =
  'FETCH_ACTIVITIES_BY_USE_CASE_ERROR'
export const FETCH_ACTIVITIES_BY_USE_CASE_DONE =
  'FETCH_ACTIVITIES_BY_USE_CASE_DONE'

// Generated by 'generate-redux'
export const SEND_TEST_EMAIL_DELIVERY = 'SEND_TEST_EMAIL_DELIVERY'
export const SEND_TEST_EMAIL_DELIVERY_LOADING =
  'SEND_TEST_EMAIL_DELIVERY_LOADING'
export const SEND_TEST_EMAIL_DELIVERY_SUCCESS =
  'SEND_TEST_EMAIL_DELIVERY_SUCCESS'
export const SEND_TEST_EMAIL_DELIVERY_ERROR = 'SEND_TEST_EMAIL_DELIVERY_ERROR'
export const SEND_TEST_EMAIL_DELIVERY_DONE = 'SEND_TEST_EMAIL_DELIVERY_DONE'

// Generated by 'generate-redux'
export const FILTER_BY_SEARCH_TERM = 'FILTER_BY_SEARCH_TERM'
export const FILTER_BY_SEARCH_TERM_LOADING = 'FILTER_BY_SEARCH_TERM_LOADING'
export const FILTER_BY_SEARCH_TERM_SUCCESS = 'FILTER_BY_SEARCH_TERM_SUCCESS'
export const FILTER_BY_SEARCH_TERM_ERROR = 'FILTER_BY_SEARCH_TERM_ERROR'
export const FILTER_BY_SEARCH_TERM_DONE = 'FILTER_BY_SEARCH_TERM_DONE'

// Generated by 'generate-redux'
export const FETCH_EVENT = 'FETCH_EVENT'
export const FETCH_EVENT_LOADING = 'FETCH_EVENT_LOADING'
export const FETCH_EVENT_SUCCESS = 'FETCH_EVENT_SUCCESS'
export const FETCH_EVENT_ERROR = 'FETCH_EVENT_ERROR'
export const FETCH_EVENT_DONE = 'FETCH_EVENT_DONE'

// Added for local cache of event details/stats
export const STORE_EVENT_CACHE = 'STORE_EVENT_CACHE'
export const USE_CACHED_EVENT = 'USE_CACHED_EVENT'

export const FETCH_EVENT_STATS = 'FETCH_EVENT_STATS'
export const FETCH_EVENT_STATS_SUCCESS = 'FETCH_EVENT_STATS_SUCCESS'
export const FETCH_EVENT_STATS_ERROR = 'FETCH_EVENT_STATS_ERROR'

// Generated by 'generate-redux'
export const FETCH_USER_DELEGATE = 'FETCH_USER_DELEGATE'
export const FETCH_USER_DELEGATE_LOADING = 'FETCH_USER_DELEGATE_LOADING'
export const FETCH_USER_DELEGATE_SUCCESS = 'FETCH_USER_DELEGATE_SUCCESS'
export const FETCH_USER_DELEGATE_ERROR = 'FETCH_USER_DELEGATE_ERROR'
export const FETCH_USER_DELEGATE_DONE = 'FETCH_USER_DELEGATE_DONE'

export const BECOME_USER_DELEGATE = 'BECOME_USER_DELEGATE'
export const BECOME_USER_DELEGATE_LOADING = 'BECOME_USER_DELEGATE_LOADING'
export const BECOME_USER_DELEGATE_SUCCESS = 'BECOME_USER_DELEGATE_SUCCESS'
export const BECOME_USER_DELEGATE_ERROR = 'BECOME_USER_DELEGATE_ERROR'
export const BECOME_USER_DELEGATE_DONE = 'BECOME_USER_DELEGATE_DONE'

// Generated by 'generate-redux'
export const FETCH_RESPONSES = 'FETCH_RESPONSES'
export const FETCH_RESPONSES_LOADING = 'FETCH_RESPONSES_LOADING'
export const FETCH_RESPONSES_SUCCESS = 'FETCH_RESPONSES_SUCCESS'
export const FETCH_RESPONSES_ERROR = 'FETCH_RESPONSES_ERROR'
export const FETCH_RESPONSES_DONE = 'FETCH_RESPONSES_DONE'

// Caching helpers for responses
export const FETCH_RESPONSES_IF_NEEDED = 'FETCH_RESPONSES_IF_NEEDED'
export const USE_CACHED_RESPONSES = 'USE_CACHED_RESPONSES'
export const STORE_RESPONSES_CACHE = 'STORE_RESPONSES_CACHE'

export const FETCH_NOTEWORTHY_SUCCESS = 'FETCH_NOTEWORTHY_SUCCESS'
export const FETCH_NOTEWORTHY_ERROR = 'FETCH_NOTEWORTHY_ERROR'

export const UPDATE_NOTEWORTHY_RESPONSES = 'UPDATE_NOTEWORTHY_RESPONSES'
export const UPDATE_NOTEWORTHY_RESPONSES_LOADING =
  'UPDATE_NOTEWORTHY_RESPONSES_LOADING'
export const UPDATE_NOTEWORTHY_RESPONSES_SUCCESS =
  'UPDATE_NOTEWORTHY_RESPONSES_SUCCESS'
export const UPDATE_NOTEWORTHY_RESPONSES_ERROR =
  'UPDATE_NOTEWORTHY_RESPONSES_ERROR'
export const UPDATE_NOTEWORTHY_RESPONSES_DONE =
  'UPDATE_NOTEWORTHY_RESPONSES_DONE'

export const FETCH_EVENT_LAYOUT = 'FETCH_EVENT_LAYOUT'
export const FETCH_EVENT_LAYOUT_SUCCESS = 'FETCH_EVENT_LAYOUT_SUCCESS'
export const FETCH_EVENT_LAYOUT_ERROR = 'FETCH_EVENT_LAYOUT_ERROR'

export const UPDATE_EVENT_LAYOUT = 'UPDATE_EVENT_LAYOUT'
export const UPDATE_EVENT_LAYOUT_LOADING = 'UPDATE_EVENT_LAYOUT_LOADING'
export const UPDATE_EVENT_LAYOUT_SUCCESS = 'UPDATE_EVENT_LAYOUT_SUCCESS'
export const UPDATE_EVENT_LAYOUT_ERROR = 'UPDATE_EVENT_LAYOUT_ERROR'
export const UPDATE_EVENT_LAYOUT_DONE = 'UPDATE_EVENT_LAYOUT_DONE'

export const FETCH_IDEAS = 'FETCH_IDEAS'
export const FETCH_IDEAS_SUCCESS = 'FETCH_IDEAS_SUCCESS'
export const FETCH_IDEAS_ERROR = 'FETCH_IDEAS_ERROR'

export const FETCH_PULSES = 'FETCH_PULSES'
export const FETCH_PULSES_SUCCESS = 'FETCH_PULSES_SUCCESS'
export const FETCH_PULSES_ERROR = 'FETCH_PULSES_ERROR'

export const FETCH_ROSTER = 'FETCH_ROSTER'
export const FETCH_ROSTER_SUCCESS = 'FETCH_ROSTER_SUCCESS'
export const FETCH_ROSTER_ERROR = 'FETCH_ROSTER_ERROR'

export const FETCH_SENTIMENT_BY_RATING = 'FETCH_SENTIMENT_BY_RATING'
export const FETCH_SENTIMENT_BY_RATING_SUCCESS =
  'FETCH_SENTIMENT_BY_RATING_SUCCESS'
export const FETCH_SENTIMENT_BY_RATING_ERROR = 'FETCH_SENTIMENT_BY_RATING_ERROR'

export const UPLOAD_ROSTER = 'UPLOAD_ROSTER'
export const UPLOAD_ROSTER_LOADING = 'UPLOAD_ROSTER_LOADING'
export const UPLOAD_ROSTER_SUCCESS = 'UPLOAD_ROSTER_SUCCESS'
export const UPLOAD_ROSTER_ERROR = 'UPLOAD_ROSTER_ERROR'
export const UPLOAD_ROSTER_DONE = 'UPLOAD_ROSTER_DONE'
export const CLEAR_ROSTER_UPLOAD = 'CLEAR_ROSTER_UPLOAD'

export const ATTACH_ROSTER = 'ATTACH_ROSTER'
export const ATTACH_ROSTER_LOADING = 'ATTACH_ROSTER_LOADING'
export const ATTACH_ROSTER_SUCCESS = 'ATTACH_ROSTER_SUCCESS'
export const ATTACH_ROSTER_ERROR = 'ATTACH_ROSTER_ERROR'
export const ATTACH_ROSTER_DONE = 'ATTACH_ROSTER_DONE'

// Generated by 'generate-redux'
export const GENERATE_PDF = 'GENERATE_PDF'
export const GENERATE_PDF_LOADING = 'GENERATE_PDF_LOADING'
export const GENERATE_PDF_SUCCESS = 'GENERATE_PDF_SUCCESS'
export const GENERATE_PDF_ERROR = 'GENERATE_PDF_ERROR'
export const GENERATE_PDF_DONE = 'GENERATE_PDF_DONE'
export const CLEAR_PDF_INFO = 'CLEAR_PDF_INFO'

export const FETCH_EVENTS_AND_PRIORITIZE = 'FETCH_EVENTS_AND_PRIORITIZE'
export const FETCH_EVENTS_AND_PRIORITIZE_START =
  'FETCH_EVENTS_AND_PRIORITIZE_START'
export const FETCH_EVENTS_AND_PRIORITIZE_LOADING =
  'FETCH_EVENTS_AND_PRIORITIZE_LOADING'
export const FETCH_EVENTS_AND_PRIORITIZE_SUCCESS =
  'FETCH_EVENTS_AND_PRIORITIZE_SUCCESS'
export const FETCH_EVENTS_AND_PRIORITIZE_ERROR =
  'FETCH_EVENTS_AND_PRIORITIZE_ERROR'
export const FETCH_EVENTS_AND_PRIORITIZE_DONE =
  'FETCH_EVENTS_AND_PRIORITIZE_DONE'

export const SYNC_FETCH_EVENTS_AND_PRIORITIZE =
  'SYNC_FETCH_EVENTS_AND_PRIORITIZE'
export const SYNC_FETCH_EVENTS_AND_PRIORITIZE_START =
  'SYNC_FETCH_EVENTS_AND_PRIORITIZE_START'
export const SYNC_FETCH_EVENTS_AND_PRIORITIZE_LOADING =
  'SYNC_FETCH_EVENTS_AND_PRIORITIZE_LOADING'
export const SYNC_FETCH_EVENTS_AND_PRIORITIZE_SUCCESS =
  'SYNC_FETCH_EVENTS_AND_PRIORITIZE_SUCCESS'
export const SYNC_FETCH_EVENTS_AND_PRIORITIZE_ERROR =
  'SYNC_FETCH_EVENTS_AND_PRIORITIZE_ERROR'
export const SYNC_FETCH_EVENTS_AND_PRIORITIZE_DONE =
  'SYNC_FETCH_EVENTS_AND_PRIORITIZE_DONE'

export const FETCH_EVENT_STATS_START = 'FETCH_EVENT_STATS_START'
export const FETCH_EVENT_STATS_DONE = 'FETCH_EVENT_STATS_DONE'
export const FETCH_EVENT_STATS_NEW_SUCCESS = 'FETCH_EVENT_STATS_NEW_SUCCESS'

export const DELETE_EVENT_OR_PRIORITIZE = 'DELETE_EVENT_OR_PRIORITIZE'
export const DELETE_EVENT_OR_PRIORITIZE_START =
  'DELETE_EVENT_OR_PRIORITIZE_START'
export const DELETE_EVENT_OR_PRIORITIZE_SUCCESS =
  'DELETE_EVENT_OR_PRIORITIZE_SUCCESS'
export const DELETE_EVENT_OR_PRIORITIZE_ERROR =
  'DELETE_EVENT_OR_PRIORITIZE_ERROR'
export const DELETE_EVENT_OR_PRIORITIZE_DONE = 'DELETE_EVENT_OR_PRIORITIZE_DONE'

// PRIORITIZE

// Prioritize create
export const FETCH_IDEA = 'FETCH_IDEA'
export const FETCH_IDEA_LOADING = 'FETCH_IDEA_LOADING'
export const FETCH_IDEA_SUCCESS = 'FETCH_IDEA_SUCCESS'
export const FETCH_IDEA_ERROR = 'FETCH_IDEA_ERROR'
export const FETCH_IDEA_DONE = 'FETCH_IDEA_DONE'

export const ADD_NEW_IDEA = 'ADD_NEW_IDEA'
export const ADD_NEW_IDEA_LOADING = 'ADD_NEW_IDEA_LOADING'
export const ADD_NEW_IDEA_SUCCESS = 'ADD_NEW_IDEA_SUCCESS'
export const ADD_NEW_IDEA_ERROR = 'ADD_NEW_IDEA_ERROR'
export const ADD_NEW_IDEA_DONE = 'ADD_NEW_IDEA_DONE'

export const REMOVE_IDEA = 'REMOVE_IDEA'
export const REMOVE_IDEA_LOADING = 'REMOVE_IDEA_LOADING'
export const REMOVE_IDEA_SUCCESS = 'REMOVE_IDEA_SUCCESS'
export const REMOVE_IDEA_ERROR = 'REMOVE_IDEA_ERROR'
export const REMOVE_IDEA_DONE = 'REMOVE_IDEA_DONE'

export const ADD_NEW_FACTOR = 'ADD_NEW_FACTOR'
export const ADD_NEW_FACTOR_LOADING = 'ADD_NEW_FACTOR_LOADING'
export const ADD_NEW_FACTOR_SUCCESS = 'ADD_NEW_FACTOR_SUCCESS'
export const ADD_NEW_FACTOR_ERROR = 'ADD_NEW_FACTOR_ERROR'
export const ADD_NEW_FACTOR_DONE = 'ADD_NEW_FACTOR_DONE'

// Prioritize collection actions
export const GET_CURRENT_COLLECTION = 'SET_CURRENT_COLLECTION'
export const DELETE_CURRENT_COLLECTION = 'DELETE_CURRENT_COLLECTION'
export const GET_RESULTS_FOR_COLLECTION = 'GET_RESULTS_FOR_COLLECTION'
export const SET_FACTORS = 'SET_FACTORS'
export const SET_CURRENT_FACTORS = 'SET_CURRENT_FACTORS'
export const SET_TEMPLATE_FACTORS = 'SET_TEMPLATE_FACTORS'

export const CREATE_QUESTIONS = 'CREATE_QUESTIONS'
export const CREATE_QUESTIONS_START = 'CREATE_QUESTIONS_START'
export const CREATE_QUESTIONS_SUCCESS = 'CREATE_QUESTIONS_SUCCESS'
export const CREATE_QUESTIONS_ERROR = 'CREATE_QUESTIONS_ERROR'
export const CREATE_QUESTIONS_DONE = 'CREATE_QUESTIONS_DONE'

export const CREATE_PRESET_QUESTIONS_SUCCESS = 'CREATE_PRESET_QUESTIONS_SUCCESS'
export const CREATE_PRESET_QUESTIONS_ERROR = 'CREATE_PRESET_QUESTIONS_ERROR'
export const CREATE_PRESET_QUESTIONS_DONE = 'CREATE_PRESET_QUESTIONS_DONE'

export const UPDATE_QUESTION = 'UPDATE_QUESTION'
export const UPDATE_QUESTION_START = 'UPDATE_QUESTION_START'
export const UPDATE_QUESTION_SUCCESS = 'UPDATE_QUESTION_SUCCESS'
export const UPDATE_QUESTION_ERROR = 'UPDATE_QUESTION_ERROR'
export const UPDATE_QUESTION_DONE = 'UPDATE_QUESTION_DONE'

export const DELETE_QUESTION = 'DELETE_QUESTION'
export const DELETE_QUESTION_START = 'DELETE_QUESTION_START'
export const DELETE_QUESTION_SUCCESS = 'DELETE_QUESTION_SUCCESS'
export const DELETE_QUESTION_ERROR = 'DELETE_QUESTION_ERROR'
export const DELETE_QUESTION_DONE = 'DELETE_QUESTION_DONE'

export const DELETE_QUESTIONS = 'DELETE_QUESTIONS'
export const DELETE_QUESTIONS_START = 'DELETE_QUESTIONS_START'
export const DELETE_QUESTIONS_SUCCESS = 'DELETE_QUESTIONS_SUCCESS'
export const DELETE_QUESTIONS_ERROR = 'DELETE_QUESTIONS_ERROR'
export const DELETE_QUESTIONS_DONE = 'DELETE_QUESTIONS_DONE'

export const FETCH_COLLECTION = 'FETCH_COLLECTION'
export const FETCH_COLLECTION_START = 'FETCH_COLLECTION_START'
export const FETCH_COLLECTION_SUCCESS = 'FETCH_COLLECTION_SUCCESS'
export const FETCH_COLLECTION_ERROR = 'FETCH_COLLECTION_ERROR'
export const FETCH_COLLECTION_DONE = 'FETCH_COLLECTION_DONE'

export const GET_PRESETS = 'GET_PRESETS'
export const GET_PRESETS_START = 'GET_PRESETS_START'
export const GET_PRESETS_SUCCESS = 'GET_PRESETS_SUCCESS'
export const GET_PRESETS_ERROR = 'GET_PRESETS_ERROR'
export const GET_PRESETS_DONE = 'GET_PRESETS_DONE'

export const SET_CURRENT_PRESET = 'SET_CURRENT_PRESET'

export const GET_QUESTIONS_BY_COLLECTION_ID = 'GET_QUESTIONS_BY_COLLECTION_ID'
export const GET_QUESTIONS_BY_COLLECTION_ID_START =
  'GET_QUESTIONS_BY_COLLECTION_ID_START'
export const GET_QUESTIONS_BY_COLLECTION_ID_SUCCESS =
  'GET_QUESTIONS_BY_COLLECTION_ID_SUCCESS'
export const GET_QUESTIONS_BY_COLLECTION_ID_ERROR =
  'GET_QUESTIONS_BY_COLLECTION_ID_ERROR'
export const GET_QUESTIONS_BY_COLLECTION_ID_DONE =
  'GET_QUESTIONS_BY_COLLECTION_ID_DONE'

export const GET_COMMENTS = 'GET_COMMENTS'
export const GET_COMMENTS_START = 'GET_COMMENTS_START'
export const GET_COMMENTS_SUCCESS = 'GET_COMMENTS_SUCCESS'
export const GET_COMMENTS_ERROR = 'GET_COMMENTS_ERROR'
export const GET_COMMENTS_DONE = 'GET_COMMENTS_DONE'

export const POST_COMMENT = 'POST_COMMENT'
export const POST_COMMENT_START = 'POST_COMMENT_START'
export const POST_COMMENT_SUCCESS = 'POST_COMMENT_SUCCESS'
export const POST_COMMENT_ERROR = 'POST_COMMENT_ERROR'
export const POST_COMMENT_DONE = 'POST_COMMENT_DONE'

export const START_TRIAL = 'START_TRIAL';
export const START_TRIAL_LOADING = 'START_TRIAL_LOADING';
export const START_TRIAL_SUCCESS = 'START_TRIAL_SUCCESS';
export const START_TRIAL_ERROR = 'START_TRIAL_ERROR';
export const START_TRIAL_DONE = 'START_TRIAL_DONE';

/**
 * AI Report Summary actions
 */
export const FETCH_AI_SUMMARY = 'FETCH_AI_SUMMARY';
export const FETCH_AI_SUMMARY_LOADING = 'FETCH_AI_SUMMARY_LOADING';
export const FETCH_AI_SUMMARY_SUCCESS = 'FETCH_AI_SUMMARY_SUCCESS';
export const FETCH_AI_SUMMARY_ERROR = 'FETCH_AI_SUMMARY_ERROR';
export const FETCH_AI_SUMMARY_DONE = 'FETCH_AI_SUMMARY_DONE';

export const GENERATE_AI_SUMMARY = 'GENERATE_AI_SUMMARY';
export const GENERATE_AI_SUMMARY_LOADING = 'GENERATE_AI_SUMMARY_LOADING';
export const GENERATE_AI_SUMMARY_SUCCESS = 'GENERATE_AI_SUMMARY_SUCCESS';
export const GENERATE_AI_SUMMARY_ERROR = 'GENERATE_AI_SUMMARY_ERROR';
export const GENERATE_AI_SUMMARY_DONE = 'GENERATE_AI_SUMMARY_DONE';

export const GENERATE_AI_WALKTHROUGH = 'GENERATE_AI_WALKTHROUGH';
export const GENERATE_AI_WALKTHROUGH_LOADING = 'GENERATE_AI_WALKTHROUGH_LOADING';
export const GENERATE_AI_WALKTHROUGH_SUCCESS = 'GENERATE_AI_WALKTHROUGH_SUCCESS';
export const GENERATE_AI_WALKTHROUGH_ERROR = 'GENERATE_AI_WALKTHROUGH_ERROR';
export const GENERATE_AI_WALKTHROUGH_DONE = 'GENERATE_AI_WALKTHROUGH_DONE';

export const FETCH_AI_MODELS = 'FETCH_AI_MODELS';
export const FETCH_AI_MODELS_LOADING = 'FETCH_AI_MODELS_LOADING';
export const FETCH_AI_MODELS_SUCCESS = 'FETCH_AI_MODELS_SUCCESS';
export const FETCH_AI_MODELS_ERROR = 'FETCH_AI_MODELS_ERROR';
export const FETCH_AI_MODELS_DONE = 'FETCH_AI_MODELS_DONE';

export const SET_SELECTED_AI_MODEL = 'SET_SELECTED_AI_MODEL';
